import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { PersonDetailComp } from './components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 3, 8),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 6),
    },
  },
}));

function PersonDetail() {
  const classes = useStyles();

  return (
    <Box justifyItems="center" className={classes.root}>
      <PersonDetailComp />
    </Box>
  );
}

export default PersonDetail;
